import React, { ReactNode } from 'react'
import styles from '~/styles/molecules/header/header_public.module.scss'
import Image from 'next/image'

import { ImagePath } from '~/common/utils/image'
import { loginPath } from '~/common/define/path'
import InternalLink from '~/components/atoms/link/InternalLink'

interface Props {
  children?: ReactNode
  isApp?: boolean
}

const PublicHeader = ({children, isApp = false}: Props) => {
  return (
    <header className={styles.public}>
      <InternalLink link={isApp ? loginPath() : '/'}>
        <picture>
        <Image
          src={ImagePath.LOGO}
          alt={'VISLITE / ビズライト ロゴ'}
          width={135}
          height={28}
        />
        </picture>
      </InternalLink>
      {children &&
        <>{children}</>
      }
    </header>
  )
}

export default PublicHeader